<template>
    <div class="build-step check-call-modal-schedule">
        <div class="title">
            <div class="move-handle">
                <icon type="dots-vertical" size="24px" />
            </div>
            <div class="name">Check Call Modal Schedule</div>
            <delete-action text rounded icon="close" message="Are you sure you want to remove this build step?"
                tooltip="Remove Build Step" @delete="removeBuildStep" />
        </div>
        <div class="description">Set the schedule of the call modal</div>
        <div class="step-settings">
            <h3>Settings</h3>
            <div class="control-group">
                <div class="inner">
                    <label class="control-label">schedule:</label>
                    <div class="controls">
                        <div class="field">
                            <code-editor v-model.parse.lazy="modelValue.config" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import deleteAction from '@/components/widgets/DeleteAction.vue';

export default {
    name: 'CheckCallModalSchedule',
    emits: ['remove'],
    components: {
        deleteAction,
    },
    props: {
        modelValue: {
            type: Object,
            default() {
                return {
                    config: {
                        schedule: {
                            monday: {
                                start: { hour: 0, minute: 0 },
                                end: { hour: 0, minute: 0 },
                            },
                            tuesday: {
                                start: { hour: 0, minute: 0 },
                                end: { hour: 0, minute: 0 },
                            },
                            wednesday: {
                                start: { hour: 0, minute: 0 },
                                end: { hour: 0, minute: 0 },
                            },
                            thursday: {
                                start: { hour: 0, minute: 0 },
                                end: { hour: 0, minute: 0 },
                            },
                            friday: {
                                start: { hour: 0, minute: 0 },
                                end: { hour: 0, minute: 0 },
                            },
                            saturday: {
                                start: { hour: 0, minute: 0 },
                                end: { hour: 0, minute: 0 },
                            },
                            sunday: {
                                start: { hour: 0, minute: 0 },
                                end: { hour: 0, minute: 0 },
                            }
                        },
                        allowed_placements: [],
                    }
                };
            }
        },
    },
    methods: {
        removeBuildStep() {
            this.$emit('remove');
        },
    },
};
</script>
